import { Grid } from "@mui/material";
import { BooleanInput, NumberInput, useTranslate } from "react-admin";

/**
 * Order and invoicing settings: which availability checks are enforced when confirming /
 * processing orders, how long a pending checkout holds seats, how long guest records
 * are kept, and whether the public account-registration form offers to create an
 * organization, and the payment term an invoice's due date is derived from.
 */
export default function OrderFields() {
  const translate = useTranslate();
  return (
    <>
      <Grid item xs={12} md={6}>
        <BooleanInput
          source="order_validation_capacity"
          label={translate("settings.order_validation_capacity.name")}
          helperText={translate("settings.order_validation_capacity.description")}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <BooleanInput
          source="order_validation_registration_window"
          label={translate("settings.order_validation_registration_window.name")}
          helperText={translate("settings.order_validation_registration_window.description")}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <BooleanInput
          source="order_validation_event_started"
          label={translate("settings.order_validation_event_started.name")}
          helperText={translate("settings.order_validation_event_started.description")}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <BooleanInput
          source="order_validation_billing_address"
          label={translate("settings.order_validation_billing_address.name")}
          helperText={translate("settings.order_validation_billing_address.description")}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <BooleanInput
          source="order_manual_processing"
          label={translate("settings.order_manual_processing.name")}
          helperText={translate("settings.order_manual_processing.description")}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <BooleanInput
          source="invoice_auto_accounting_transfer"
          label={translate("settings.invoice_auto_accounting_transfer.name")}
          helperText={translate("settings.invoice_auto_accounting_transfer.description")}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <NumberInput
          source="order_checkout_window_minutes"
          label={translate("settings.order_checkout_window_minutes.name")}
          helperText={translate("settings.order_checkout_window_minutes.description")}
          min={1}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <NumberInput
          source="order_unverified_user_retention_days"
          label={translate("settings.order_unverified_user_retention_days.name")}
          helperText={translate("settings.order_unverified_user_retention_days.description")}
          min={0}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <NumberInput
          source="invoice_payment_term_days"
          label={translate("settings.invoice_payment_term_days.name")}
          helperText={translate("settings.invoice_payment_term_days.description")}
          min={0}
        />
      </Grid>
    </>
  );
}
